import { type Enum } from '@webapp/infrastructure/types/Enum'

export const PaymentMethodManagementTypes = {
  EXTERNAL: 'external',
  MANAGED: 'managed',
} as const

export type PaymentMethodManagementTypeEnum = Enum<
  typeof PaymentMethodManagementTypes
>
